import lmsCategorySlice from "../category_tree/redux/categorySlice";
import lmsSkillSlice from "../skills/redux/skillSlice";
import lmsMediaSlice from "../media/redux/mediaSlice";
import lmsCoursesSlice from "../courses/redux/coursesSlice";
import courseAssignmentSlice from "../course-assignment/redux/courseAssignmentSlice";

export const lmsCategory = lmsCategorySlice;
export const lmsSkill = lmsSkillSlice;
export const lmsMedia = lmsMediaSlice;
export const lmsCourses = lmsCoursesSlice;
export const courseAssignment = courseAssignmentSlice;
